import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon, Text, Link } from 'reaxl';

/**
 * Renders a menu link for navigation.
 * @param {Object} navItem - The navigation item data.
 * @returns {JSX.Element} The rendered menu link.
 */
export default function HeaderBadgeMenuLinks(_ref) {
  let {
    navItem
  } = _ref;
  const {
    eventkey,
    href,
    label,
    glyph,
    onClick
  } = navItem;
  const handleClick = e => {
    onClick(e, navItem);
  };
  return /*#__PURE__*/_jsx("li", {
    "data-cmp": "slidingMenuLink"
  }, `${label}-${eventkey}`, /*#__PURE__*/_jsx(Link, {
    className: "display-flex align-items-center gap-3 padding-left-0",
    href: href,
    onClick: handleClick
  }, void 0, /*#__PURE__*/_jsx(Glyphicon, {
    "data-cmp": "slidingMenuLinkIcon",
    className: "text-size-500",
    glyph: glyph
  }), /*#__PURE__*/_jsx(Text, {
    transformCase: "capitalize",
    weight: "normal",
    size: 300
  }, void 0, label)));
}